import { IGif } from '@giphy/js-types'
import { createContext } from 'react'
import { IChannel } from 'shared/types/channel'
import { NewCollectionProps } from '../collections/modal'
import { EditPanelSections } from '../edit-panel/gif-detail'

const noop = (...args) => console.log(...args)

type ModalContextProps = {
    openGifEditPanel: (gif: IGif, section?: EditPanelSections) => void
    openBulkEditPanel: (allowBulkEditMode: boolean) => void
    openNewCollectionPanel: (newCollectionProps: NewCollectionProps) => void
    openEditCollectionPanel: (channel: IChannel) => void
    openCollectionCabinet: (channelId?: number) => void
    openAddGifsToCollectionPanel: (channelId: number, searchChannelId: number) => void
}

const ModalContext = createContext({
    openCollectionCabinet: noop,
    openEditCollectionPanel: noop,
    openNewCollectionPanel: noop,
    openGifEditPanel: noop,
    openBulkEditPanel: noop,
    openAddGifsToCollectionPanel: noop,
} as ModalContextProps)

export default ModalContext
